// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITransactionReportDestinationDto } from './ITransactionReportDestinationDto';
import {
    ITransactionReportDestinationDtoFromJSON,
    ITransactionReportDestinationDtoFromJSONTyped,
    ITransactionReportDestinationDtoToJSON,
    ITransactionReportDestinationDtoToJSONTyped,
} from './ITransactionReportDestinationDto';

/**
 * 
 * @export
 * @interface IReportDto
 */
export interface IReportDto {
    /**
     * 
     * @type {Set<ITransactionReportDestinationDto>}
     * @memberof IReportDto
     */
    transaction_creations?: Set<ITransactionReportDestinationDto>;
    /**
     * 
     * @type {Set<ITransactionReportDestinationDto>}
     * @memberof IReportDto
     */
    released_holds?: Set<ITransactionReportDestinationDto>;
}

/**
 * Check if a given object implements the IReportDto interface.
 */
export function instanceOfIReportDto(value: object): value is IReportDto {
    return true;
}

export function IReportDtoFromJSON(json: any): IReportDto {
    return IReportDtoFromJSONTyped(json, false);
}

export function IReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transaction_creations': json['transaction_creations'] == null ? undefined : (new Set((json['transaction_creations'] as Array<any>).map(ITransactionReportDestinationDtoFromJSON))),
        'released_holds': json['released_holds'] == null ? undefined : (new Set((json['released_holds'] as Array<any>).map(ITransactionReportDestinationDtoFromJSON))),
    };
}

export function IReportDtoToJSON(json: any): IReportDto {
    return IReportDtoToJSONTyped(json, false);
}

export function IReportDtoToJSONTyped(value?: IReportDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transaction_creations': value['transaction_creations'] == null ? undefined : (Array.from(value['transaction_creations'] as Set<any>).map(ITransactionReportDestinationDtoToJSON)),
        'released_holds': value['released_holds'] == null ? undefined : (Array.from(value['released_holds'] as Set<any>).map(ITransactionReportDestinationDtoToJSON)),
    };
}

